
export class StreamReport {
    constructor(
        public currentTime: number,
        public totalTime: number = 0,
        public durationWatched: number) {
    }
}
